'use strict';

angular.module('amexReconciliationApp')
    .component('btaAccountList', {
    templateUrl: 'scripts/views/components/bta-account-list.html',
    controller: function(TransactionSearchModel,
        AccountListService,
        BtaAccountModel,
        BtaAccountsRepository,
        PaginationModelFactory,
        BTASortModel,
        BTAFilterModel,
        $scope,
        UserModel,
        roles,
        $state, AdobeAnalyticsService) {
        var self = this;
        var PAGE_SIZE = 20;
        var btaPaginationModel = PaginationModelFactory.create(PAGE_SIZE);

        self.loading = true;
        self.rowLoading = null;

        self.isSuperAdmin = UserModel.isSuperAdmin;

        //ToDo : Setup a BTA user and remove this logic
        self.isBCAManagerViewSelected  = UserModel.isBCAManagerViewSelected;

        self.roles = UserModel.roles();
        self.currentRole = TransactionSearchModel.role();

        self.onRoleChanged = function () {
            AccountListService.roleChange(self.currentRole);
        };

        BTASortModel.onBtasChanged($scope, function (btas) {
            btaPaginationModel.repaginate(btas);
        });

        self.pageStart = btaPaginationModel.pageStart;
        self.pageEnd = btaPaginationModel.pageEnd;
        self.pageSize = btaPaginationModel.pageSize;
        self.currentPage = btaPaginationModel.pageNumber;
        self.totalCount = btaPaginationModel.totalCount;
        self.showPagination = btaPaginationModel.showPagination;
        self.updateCurrentPage = btaPaginationModel.updateCurrentPage;
        self.btaFilter = BTAFilterModel.filter;
        self.btas = [];

        var openedRow = null;

        self.$onInit = function() {
            BtaAccountsRepository.get().then(function(btas) {
            BTAFilterModel.unfilteredBtas(btas);
            }).finally(function() {
            self.loading = false;
            if(self.btas.length === 1) {
                var bta = self.btas[0];
                self.toggleRow(0, bta.accountNumber, bta.accountName, bta.statementDate, bta.transactionTotal, bta.siteName);
                }
            });
        };

        btaPaginationModel.onRecordsOnCurrentPageChanged($scope, function () {
            self.btas = btaPaginationModel.recordsOnCurrentPage();
        });


        self.toggleRow = function (index, accountNumber, accountName) {
            if(self.btas[index].statements.length === 0) { return; }

            if(openedRow === index) {
                openedRow = null;
            } else {
                if(self.btas[index].statements.length === 1) {
                    self.rowLoading = index;
                    BtaAccountsRepository.getStatements(accountNumber).then(function success(btaStatemnets) {
                        self.btas[index].statements = btaStatemnets;
                        self.rowLoading = null;
                    });
                }
                openedRow = index;
            }
        };

        self.isRowOpen = function (index) {
            return openedRow === index;
        };

        self.rowspanForRow = function (index) {
            if(self.isRowOpen(index)) {
                return self.btas[index].statements.length + 1;
            } else {
                return 2;
            }
        };

        self.enableAccountTooltip = function(index) {
            return self.hasStatements(index) && !self.isRowOpen(index);
        };

        self.statementsForRow = function(index, accountNumber) {
            var emptyStatement = {statementKey: ''};
            var btaKey = {'accountNumber': accountNumber};
            if (self.isRowOpen(index)) {
                return _.find(self.btas, btaKey).statements;
            } else if (null == _.find(self.btas, btaKey).statements) {
                return emptyStatement;
            } else {
                return [_.find(self.btas, btaKey).statements[0]];
            }
        };

        self.showLockIcon = AccountListService.showLockIcon;

        self.getLockColor = AccountListService.getLockColor;

        self.getLockStatusToolTip = AccountListService.getLockStatusToolTip;

        self.hasStatements = function(index) {
            return self.btas[index].statements && self.btas[index].statements.length > 0;
        };


        self.getCurrencyFormat = UserModel.getCurrencyFormat;

        self.isAccordionOpen = function(index) {
            return  self.isRowOpen(index) && self.btas[index].statements.length > 1;
        };

        self.hasBtas = function() {
            return !_.isEmpty(self.btas);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/btaAccountList.js
// module id = 439
// module chunks = 0